import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    content: {
        flex: 1,
        width: '100% !important',
    },
}));
